export enum InnerCardValueColorEnum {
  DEFAULT = 'default',
  INFO = 'info',
  POSITIVE = 'positive',
  NEGATIVE = 'negative'
}
